<template>
  <v-container fluid class="financereport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="3" class="d-flex flex-start justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-2"
                @click="findFinanceReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/financereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn 
                color="primary" 
                class="button-shadow mr-2"
                @click="printItem"
                v-show="data_reports.length>0"
              >
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_reports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="data_reports-table"
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="header_order"
              :items="data_reports"
              :items-per-page="itemPerPage">
              <template v-slot:item.orderdate="{ item }">
                {{ item.orderdate!=null ? new Date(item.orderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.orderduedate="{ item }">
                {{ item.orderduedate!=null ? new Date(item.orderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
              </template>
              <template v-slot:item.orderimage="{ item }">
                  <img v-bind:src="item.orderimage" alt="" width="60">
              </template>
              <template v-slot:item.days_0="{ item }">
                {{ item.days_0!==undefined ? (item.days_0).toFixed(1) : '' }}
              </template>
              <template v-slot:item.days_31="{ item }">
                {{ item.days_31!==undefined ? (item.days_31).toFixed(1) : '' }}
              </template>
              <template v-slot:item.days_61="{ item }">
                {{ item.days_61!==undefined ? (item.days_61).toFixed(1) : '' }}
              </template>
              <template v-slot:item.days_90="{ item }">
                {{ item.days_90!==undefined ? (item.days_90).toFixed(1) : '' }}
              </template>
              <template v-slot:item.balance="{ item }">
                {{ item.balance!==undefined ? (item.balance).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findFinanceReportDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Finance Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="find_query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findFinanceReportDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findFinanceReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FinanceReportReceivablesAging',
  data() {
    return {
      header_order: [
        { text: 'Customer Name', value: 'customername', align: 'left' },
        { text: 'Balance', value: 'balance', width: '12%', align: 'right', format: 'decimal' },
        { text: '0-30', value: 'days_0', width: '12%', align: 'right', format: 'decimal' },
        { text: '31-60', value: 'days_31', width: '12%', align: 'right', format: 'decimal' },
        { text: '61-90', value: 'days_61', width: '12%', align: 'right', format: 'decimal' },
        { text: '90+', value: 'days_90', width: '12%', align: 'right', format: 'decimal' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findFinanceReportDialog: false,
      find_query: {},
      data_reports: [],
      data: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
      companyid: null,
      report_name: 'Accounts Receivables Aging',
      report_date: new Date(),
    }
  },
  computed: {
    ...mapState('FinanceReport', ['report', 'financereports', 'isDeleting', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('Region', ['regions']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
    data_channels(){
      return this.saleschannels.filter(x=>x.channelstatus=='Active' || x.channelstatus=='New').map(x => {return {text: x.channelname, value: x._id};});
    },
    data_locations(){
      return this.locations.filter(x=>x.locationstatus=='Active' || x.locationstatus=='New').map(x => {return {text: x.locationname, value: x._id};});
    },
    data_users(){
      return this.users.filter(x=>x.userstatus=='Active' && x.locationid==this.find_query.locationid).map(x => {return {text: x.username, value: x._id};});
    }
  },
  methods: {
    ...mapActions('FinanceReport', ["setReport", "findFinanceReportReceivablesAgingRequest", "getFinanceReportReceivablesAgingRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    printItem() {
      
      let report = {companyid: this.companyid, report_date: this.report_date, report_name: this.report_name}
      this.$router.push({ name: 'PrintReport', params: {report: report, data: this.data_reports, header: this.header_order} });
    },
    calculateTotal(){
      this.data_reports = [];
      this.report_date = this.financereports.length>0 ? new Date(this.financereports[0]['report_date']) : new Date();
      let categories = ['0-30', '31-60', '61-90', '90-'];
      let object = Object.groupBy(this.financereports, item => { return item.customerid });
      let customers = Object.keys(object);
      console.log(customers)
      for(var item of customers){
        let balance;
        let customername = item!='null' ? this.financereports.find(x=>x.customerid==item)['customername'] : 'None';
        if(item=='null') balance = this.financereports.filter(x=>x.customerid==null).reduce(function (last, json) {return last + json.balance;}, 0);
        else balance = this.financereports.filter(x=>x.customerid==item).reduce(function (last, json) {return last + json.balance;}, 0);        let json = {
          customerid: item,
          customername: customername,
          balance: balance,
        };
        for(var cat of categories){
          let text = cat.split("-")[0];
          let find = this.financereports.find(x=>x.customerid==item && x.due_class==cat);
          json[`days_${text}`] = find!=null ? find.balance : 0;
        }
        this.data_reports.push(json);
      }
      this.data_reports.push({
        balance: this.data_reports.reduce(function (last, json) {return last + json.balance;}, 0),
        days_0: this.data_reports.reduce(function (last, json) {return last + json.days_0;}, 0),
        days_31: this.data_reports.reduce(function (last, json) {return last + json.days_31;}, 0),
        days_61: this.data_reports.reduce(function (last, json) {return last + json.days_61;}, 0),
        days_90: this.data_reports.reduce(function (last, json) {return last + json.days_90;}, 0),
        isSum: true,
      });
    },
    async findFinanceReport(){
      this.findFinanceReportDialog = false;
      if(Object.keys(this.find_query).length==0){
        await this.getFinanceReportReceivablesAgingRequest();
        this.calculateTotal();
      }
      else{
        await this.findFinanceReportReceivablesAgingRequest(this.find_query);
        this.calculateTotal();
      }
    },
    getJson(){
      let json = this.data_reports.map(report=>{return {
        report_date:  this.report_date!=null && report.customername!=null ? new Date(this.report_date).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        customername: report.customername,
        balance: report.balance ? report.balance.toFixed(2) : 0,
        days_0_30: report.days_0 ? report.days_0.toFixed(2) : 0, 
        days_31_60: report.days_31 ? report.days_31.toFixed(2) : 0, 
        days_61_90: report.days_61 ? report.days_61.toFixed(2) : 0, 
        days_90: report.days_90 ? report.days_90.toFixed(2) : 0, 
      }});
      return json;
    },
    getFileName(){
      var d = this.report_date;
      var name = 'finance-receivables-aging-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
  },
  async created () {
    if(this.report!=this.report_name || (this.financereports==null || this.financereports.length==0)) await this.getFinanceReportReceivablesAgingRequest();
    this.calculateTotal();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    this.companyid = localStorage.getItem('companyid');
    this.setReport(this.report_name);
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
